export default "__VITE_ASSET__BkJeE36E__"